import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { ContractHours } from '../../../models/employee/ContractHours';
import { EmployeeContractHoursResponse } from '../../../../interfaces/response/EmployeeResponse';
import moment from 'moment';

/**
 * An adapter converts contract hours HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class ContractHoursAdapter implements Adapter<ContractHours[]> {

  /**
   * Converts contract hours HTTP response to a list of {@link ContractHours}.
   * @param item contract hours HTTP response.
   */
  adapt(item: EmployeeContractHoursResponse[]): ContractHours[] {
    if (!item) {
      return [];
    }
    const result: ContractHours[] = [];
    item.forEach($item => {
      const hours = moment.duration($item.duration).asHours();
      result.push(new ContractHours(hours, $item.date));
    });
    return result.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
